module.exports = __webpack_public_path__ + "img/icon_11.2d6db537.svg";